export default "__VITE_ASSET__DU$376Fh__"